<section class="main-section reset-password-sent-section">
	<h1>Reset Password</h1>
	<div>
		<p>We've sent a password reset link to your email address. Please check your inbox or spam folder.</p>
	</div>
</section>
